const flattenMessages = (value) => {
  if (value == null) return [];
  if (typeof value === "string") return [value];
  if (Array.isArray(value)) return value.flatMap(flattenMessages);
  if (typeof value === "object") return Object.values(value).flatMap(flattenMessages);
  return [String(value)];
};

export const getQuoteApiErrorMessage = (response) => {
  const payload = response?.response?.data;
  if (!payload) return "";

  if (typeof payload === "string" && payload.trim()) return payload;

  if (Array.isArray(payload)) {
    return flattenMessages(payload).filter((m) => String(m).trim()).join("\n");
  }

  if (payload?.Errors != null) {
    const fromErrors = flattenMessages(payload.Errors).filter((m) => String(m).trim());
    if (fromErrors.length) return fromErrors.join("\n");
  }

  if (payload?.errors != null) {
    const fromErrors = flattenMessages(payload.errors).filter((m) => String(m).trim());
    if (fromErrors.length) return fromErrors.join("\n");
  }

  const fromPayload = flattenMessages(payload).filter((m) => String(m).trim());
  if (fromPayload.length) return fromPayload.join("\n");

  if (payload?.detail) return payload.detail;
  if (payload?.title) return payload.title;
  if (payload?.message && !String(payload.message).includes("status code")) {
    return payload.message;
  }

  return "";
};
